var map = {
	"./AI.png": 135,
	"./asp.net_.jpg": 136,
	"./bip.svg": 137,
	"./brijlal.png": 138,
	"./css.svg": 139,
	"./cyber.jpg": 140,
	"./java-logo.png": 141,
	"./kavita.svg": 142,
	"./mongo.png": 143,
	"./photoshop.svg": 144,
	"./python.png": 145,
	"./react.png": 146,
	"./shikhar.jpg": 147,
	"./sipnalogo.png": 148,
	"./skillenza.png": 149,
	"./ssgandhy.png": 150,
	"./tcs.jpg": 151,
	"./valora.jpg": 152,
	"./wrighter.jpg": 153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;